const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_clean-toronto/artifacts/btkpgna2_IMG_4997%20%281%29.jpeg";

/**
 * Logo with white background removed via CSS blend modes.
 * variant="light" -> use on white/light backgrounds (mix-blend-multiply)
 * variant="dark"  -> use on black/dark backgrounds (mix-blend-screen)
 */
export default function Logo({ variant = "light", size = 40, withWordmark = false, className = "" }) {
  const blend = variant === "dark" ? "mix-blend-screen" : "mix-blend-multiply";
  return (
    <span
      data-testid="logo-mark"
      className={`inline-flex items-center gap-2 ${className}`}
    >
      <img
        src={LOGO_URL}
        alt="Pristyn Cleaning Services"
        width={size}
        height={size}
        loading="eager"
        className={`block ${blend}`}
        style={{ width: size, height: size, objectFit: "cover", objectPosition: "center" }}
      />
      {withWordmark && (
        <span className="font-display text-xl font-extrabold tracking-tight">
          Pristyn<span className="text-[var(--pc-green-hover)]">.</span>
        </span>
      )}
    </span>
  );
}

export { LOGO_URL };
